<template>
  <div>
    <el-popover
      placement="bottom-start"
      width="240"
      trigger="click"
      @show="isCopied = false, isPermitChanged = false"
    >
      <template #reference>
        <button class="tw-transition tw-opacity-0 group-hover:tw-opacity-100 hover-none:tw-opacity-100 tw-ml-4 tw-mt-1 tw--mr-2 tw-text-gray-dark dark:tw-text-dm-gray-dark hover:tw-text-dark dark:hover:tw-text-dm-dark">
          <icon-dots-vertical class="tw-w-4" />
        </button>
      </template>

      <div>
        <transition
          enter-active-class="tw-duration-100 tw-ease-out"
          enter-class="tw-translate-x-1/2 tw-opacity-0"
          enter-to-class="tw-translate-x-0 tw-opacity-100"
          leave-active-class="tw-duration-100 tw-ease-in"
          leave-class="tw-translate-x-0 tw-opacity-100"
          leave-to-class="tw-translate-x-1/2 tw-opacity-0"
        >
          <div
            v-show="isPermitEditOpen"
            class="tw-p-5 tw-pb-3 tw-transform"
          >
            <i-button
              size="medium"
              class="tw-mb-1"
              is-icon
              @click="isPermitEditOpen = false"
            >
              <icon-angle-left />
            </i-button>
            <div
              v-loading="isPermitChanging"
              class="tw-divide-y tw-divide-gray dark:tw-divide-dm-gray"
            >
              <div
                v-for="permit in permits"
                :key="permit.id"
              >
                <button
                  class="tw-text-base tw-text-dark dark:tw-text-dm-dark tw-flex tw-items-center tw-py-3 hover:tw-text-primary dark:hover:tw-text-dm-primary"
                  @click="changePermit(permit.id)"
                >
                  {{ permit.permit_type_name }}
                  <template v-if="permit.reference_number">
                    ({{ permit.reference_number }})
                  </template>
                </button>
              </div>
            </div>
          </div>
        </transition>
        <div
          v-show="!isPermitEditOpen"
          class="tw-divide-y tw-divide-gray dark:tw-divide-dm-gray"
        >
          <div>
            <button
              class="tw-text-base tw-text-dark dark:tw-text-dm-dark tw-flex tw-items-center tw-p-5"
              :class="isPermitChanged ? 'tw-text-success' : 'hover:tw-text-primary dark:hover:tw-text-dm-primary'"
              @click="isPermitEditOpen = true"
            >
              <template v-if="isPermitChanged">
                <icon-check class="tw-mr-2" />
                <span>
                  Permit changed!
                </span>
              </template>
              <template v-else>
                <icon-screen-list class="tw-mr-2" />
                <span>
                  Edit permit...
                </span>
              </template>
            </button>
          </div>
          <div>
            <button
              class="tw-text-base tw-text-dark dark:tw-text-dm-dark tw-flex tw-items-center tw-p-5"
              :class="isCopied ? 'tw-text-success' : 'hover:tw-text-primary dark:hover:tw-text-dm-primary'"
              @click="copyText"
            >
              <template v-if="isCopied">
                <icon-check class="tw-mr-2" />
                <span>
                  Copied!
                </span>
              </template>
              <template v-else>
                <icon-fullscreen class="tw-mr-2" />
                <span>
                  Copy text
                </span>
              </template>
            </button>
          </div>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    message: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isCopied: false,
      isPermitChanging: false,
      isPermitChanged: false,
      isPermitEditOpen: false,
    };
  },

  computed: {
    ...mapState({
      foreigner: (state) => state.v2.admin.messaging.foreigner,
      rawPermits: (state) => state.v2.admin.foreigners.foreigner.permits,
    }),
    permits() {
      return [
        ...this.rawPermits,
        {
          id: null,
          permit_type_name: this.$capitalize(this.$t('messaging.subject.other')),
        },
      ];
    },

  },

  methods: {
    async changePermit(permitId) {
      this.isPermitChanging = true;
      await this.$store.dispatch('v2/admin/messaging/changeMessagePermit', {
        foreignerId: this.foreigner?.id,
        messageId: this.message.id,
        permitId,
      });
      await this.$store.dispatch('v2/admin/messaging/loadThreads', this.foreigner?.id);
      this.isPermitChanging = false;

      this.isPermitChanged = true;
      this.isPermitEditOpen = false;
    },

    copyText() {
      this.isCopied = false;
      window.navigator.clipboard.writeText(this.message.body);
      this.isCopied = true;
    },
  },
};
</script>
